import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class RequestCacheService {
    private cache = new Map<string, [Date, HttpResponse<any>]>();

    get(key): HttpResponse<any> {
        const tuple = this.cache.get(key);
        if (!tuple) { return null; }

        const expires = tuple[0];
        const httpResponse = tuple[1];

        // let httpResponse = [];
        //
        // caches.open('mycache')
        //     .then(cache => {
        //         cache.match(key)
        //             .then(response => {
        //                 console.log(key, response);
        //                 httpResponse.push(response);
        //                 console.log('httpResponse' + JSON.stringify(httpResponse));
        //                 return httpResponse;
        //             });
        //     });

        // const httpResponse = new HttpResponse().clone(JSON.parse(localStorage.getItem(key)));

        // Don't observe expired keys
        const now = new Date();
        if (expires && expires.getTime() < now.getTime()) {
            this.cache.delete(key);
            // localStorage.removeItem(key);
            return null;
        }

        return httpResponse;
    }

    set(key, value, ttl = null) {
        if (ttl) {
            const expires = new Date();
            expires.setSeconds(expires.getSeconds() + ttl);
            this.cache.set(key, [expires, value]);

            // caches.open('mycache')
            //     .then(cache => {
            //         // cache.put(key, new Response(JSON.stringify(value)));
            //         cache.put(key, new Response(value));
            //     });
            //
            // localStorage.setItem(key, JSON.stringify(value) );
        } else {
            this.cache.set(key, [null, value]);
            // localStorage.removeItem(key);
        }
    }
}
